import React from "react";
import CardPopUp from "../../newComponents/cardPopUp";
import YoutubeEmbed from "../../newComponents/youtubeEmbed";

const relatedTeamMembers = ({ block }) => (
  <section className="section-listing js-section-listing">
    <div className="shell">
      {block.headline ?
        <header className="section__head">
          <p className="section__title title h2 text-gray">{block.headline}</p>
        </header>
        :
        <></>
      }
      <div className="boxes swiper-container js-load-more js-slider-boxes-projects">
        <ul>
          {block.featuredTeamMembers.map((item, i) =>  (
            <CardPopUp isStaff={true} key={item.displayTitle} ar={1/1} image={item.featureImage[0]} title={item.displayTitle} subtitle={item.position} readMoreLabel={"View video"} modalTitle={item.displayTitle}>
              <YoutubeEmbed title={item.staffCareersVideo.title} url={item.staffCareersVideo.url}/>
            </CardPopUp>
          ))}
        </ul>
        <div className="swiper-pagination boxes__pagination" />
      </div>
    </div>
  </section>
)

export default relatedTeamMembers;